import React from "react";
import {
  Box,
  Typography,
  LinearProgress,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { MessageCircle } from "lucide-react";
import useFreeMessages from "../../hooks/useFreeMessages";

const FreeMessagesWidget: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { status, loading } = useFreeMessages();

  if (loading || !status?.isViewer) {
    return null;
  }

  const progressPercentage = (status.freeMessagesUsed / 2) * 100;

  return (
    <Box
      style={{
        backgroundColor: "#1a1a1a",
        border: "1px solid #333",
        borderRadius: "8px",
        padding: isMobile ? "8px 12px" : "12px 16px",
        margin: isMobile ? "8px 0" : "12px 0",
        display: "flex",
        alignItems: "center",
        gap: "12px",
      }}
    >
      <MessageCircle
        size={isMobile ? 16 : 20}
        style={{ color: "#FE5A97", flexShrink: 0 }}
      />

      <Box style={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="body2"
          style={{
            color: "#fff",
            fontSize: isMobile ? "12px" : "14px",
            fontWeight: 500,
            marginBottom: "4px",
          }}
        >
          {status.freeMessagesRemaining} з 2 безкоштовних повідомлень залишилось
        </Typography>

        <Box style={{ position: "relative" }}>
          <LinearProgress
            variant="determinate"
            value={progressPercentage}
            style={{
              height: "4px",
              borderRadius: "2px",
              backgroundColor: "#333",
            }}
          />
        </Box>

        {status.freeMessagesRemaining === 0 && (
          <Typography
            variant="caption"
            style={{
              color: "#ff4444",
              fontSize: "11px",
              marginTop: "2px",
              display: "block",
            }}
          >
            Скидання о 00:00 UTC
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default FreeMessagesWidget;
